import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { links } from '../../../constants/links';
import BackBtn from '../BackBtn/BackBtn';
import HeadingBlock from '../HeadingBlock/HeadingBlock';
import Toolbar from '../../common/Toolbar/Toolbar';
import HouseNav from '../HouseNav/HouseNav';
import FlatActions from '../FlatActions/FlatActions';
import { getHousePageSubtitle } from '../../../utils/getHousePageSubtitle';
import useCurrentAddress from '../../../hooks/useCurrentAddress';
import HouseAcceptanceNotice from '../HouseAcceptanceNotice/HouseAcceptanceNotice';
import { HOUSE_ACCEPTANCE_STAGE_ID } from '../../../constants/common';
import styles from './HouseHeader.module.scss';

const {
  rootWithCompany,
  houses,
  house: {
    pages: { flats },
  },
} = links;

const HouseHeader = ({ className }) => {
  const { companyId, pageId: houseId, pageTabId: flatId } = useParams();
  const location = useLocation();

  const { currentHouse, currentFlat } = useSelector(
    (state) => state.housingStockStore
  );

  const link = location.state?.from
    ? `/${location.state.from}`
    : flatId
    ? `${rootWithCompany}/${companyId}/${houses}/${houseId}/${flats}`
    : `${rootWithCompany}/${companyId}/${houses}`;

  const address = useCurrentAddress();
  const subtitle = getHousePageSubtitle(currentHouse, currentFlat?.clients);

  return (
    <div className={styles.root}>
      <Toolbar background="dark" className={className}>
        <BackBtn className={styles.backButton} link={link} />
        <HeadingBlock
          title={address}
          subtitle={subtitle}
          wrapClassName={styles.heading}
        />
        <div className={cn(styles['ml-auto'], styles.rightCol)}>
          {currentHouse?.houseStageId === HOUSE_ACCEPTANCE_STAGE_ID && (
            <HouseAcceptanceNotice
              className={styles.acceptance}
              btnClassName={cn({
                [styles.repeatNoticeBtn]: currentHouse?.acceptanceCreateDate,
              })}
              text={
                currentHouse?.acceptanceCreateDate
                  ? 'Оповестить повторно'
                  : 'Оповещение о приемке'
              }
            />
          )}
          {flatId ? <FlatActions address={address} /> : <HouseNav />}
        </div>
      </Toolbar>
    </div>
  );
};

export default HouseHeader;
